// extracted by mini-css-extract-plugin
export default {"PageNav":"PageNav_PageNav__Srpht","page":"PageNav_page__s+iXC"};